import { useState, useEffect, useRef } from "react";
import {
  Typography,
  Box,
  Button,
  TextField,
  InputBase,
  Tooltip,
  CardMedia,
  IconButton,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsGotoLast, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseUserPollManagment } from "./UseUserPollManagment";
import CheckIcon from "@mui/icons-material/Check";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import { deCapitalizeFirstLetter } from "../../util/Utils";
import ProgressCom from "../../components/ProgressCom";
import { toMoney } from "../../util/Utils";
import DeleteRow from "../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";

export default function UserPollManagment(props) {
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC();
  let navigate = useNavigate();
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetUserPoll, deleteUserPoll, UpdateUserPoll } =
    UseUserPollManagment();
  const [pollRes, setPollRes] = useState();
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );

  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    GetUserPoll(
      myPc,
      search,
      (polls) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(polls.pageCondition.totalPage);
          return;
        }
        setPollRes(polls);
      },
      true
    );
  }, [myPc]);

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/userpollmanagment/addPoll", {
      state: {
        myPc: myPc,
        search: search,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 70,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      sortable: false,
    },

    {
      field: "question",
      headerName: "سوال",
      width: 250,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.question}
          </Typography>
        );
      },
    },
    {
      field: "orderTypeTitle",
      headerName: "نوع ارسال",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.orderTypeTitle}
          </Typography>
        );
      },
    },
    {
      field: "rowIndex",
      width: 70,
      align: "center",
      headerName: "اولویت",
      headerAlign: "center",
    },
    {
      field: "isActive",
      headerName: "وضعیت",
      width: 80,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return cellValues.row.isActive ? (
          <CheckIcon style={{ color: "#618833" }} />
        ) : (
          <CloseOutlinedIcon style={{ color: "red" }} />
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 220,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.isActive == false ? (
              <Button
                onClick={() => {
                  setCheckState({
                    show: true,
                    sendModel: {
                      id: cellValues.row.id,
                      isActive: true,
                    },
                    name: "فعال کردن نظرسنجی",
                  });
                }}
                color="success"
                variant="contained"
              >
                فعال
              </Button>
            ) : (
              <Button
                onClick={() => {
                  setCheckState({
                    show: true,
                    sendModel: {
                      id: cellValues.row.id,
                      isActive: false,
                    },
                    name: "غیرفعال کردن نظرسنجی",
                  });
                }}
                color="error"
                variant="contained"
              >
                غیرفعال
              </Button>
            )}
            <Tooltip title="Delete">
              <IconButton
                sx={{ ml: 1 }}
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: "",
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                onClick={() => {
                  setScrollTo(cellValues.api.getScrollPosition());

                  return navigate("/userpollmanagment/editPoll", {
                    state: {
                      model: cellValues.row,
                      myPc: myPc,
                      search: search,
                      id: cellValues.row.id,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  question: cellValues.row.question,
                  orderType: cellValues.row.orderType,
                  isActive: cellValues.row.isActive,
                  hasDescribe: cellValues.row.hasDescribe,
                  hasGraid: cellValues.row.hasGraid,
                  orderTypeTitle: cellValues.row.orderTypeTitle,
                  rowIndex: cellValues.row.rowIndex - 1,
                };
                if (cellValues.row.rowIndex - 1 == 0) {
                  return;
                } else {
                  setProgress(true);
                  UpdateUserPoll(model, () => {
                    GetUserPoll(
                      myPc,
                      search,
                      (polls) => {
                        setPollRes(polls);
                      },
                      false
                    );
                  });
                }
              }}
            >
              <ArrowUpwardIcon fontSize="small" sx={{}} />
            </IconButton>
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  question: cellValues.row.question,
                  orderType: cellValues.row.orderType,
                  isActive: cellValues.row.isActive,
                  hasDescribe: cellValues.row.hasDescribe,
                  hasGraid: cellValues.row.hasGraid,
                  orderTypeTitle: cellValues.row.orderTypeTitle,
                  rowIndex: cellValues.row.rowIndex + 1,
                };
                if (cellValues.row.rowIndex + 1 == pollRes.poll.length + 1) {
                  return;
                } else {
                  setProgress(true);
                  UpdateUserPoll(model, () => {
                    GetUserPoll(
                      myPc,
                      search,
                      (polls) => {
                        setPollRes(polls);
                      },
                      false
                    );
                  });
                }
              }}
            >
              <ArrowDownwardIcon fontSize="small" sx={{}} />
            </IconButton>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 210,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "ارتباط با مشتری",
        childs: [{ name: msActiveMenu.pageTitle, url: "/userpollmanagment" }],
      }}
    >
      {pollRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={pollRes.pageCondition.pageCount}
          rows={pollRes.poll}
          paginationMode="server"
          page={pollRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={pollRes.pageCondition.totalItemCount}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              isLtr: true,
              newFunc: newFunc,
              rowCount: pollRes.pageCondition.totalItemCount,
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"نظرسنجی"}
        callback={() => {
          setProgress(true);
          deleteUserPoll(deleteState.id, () => {
            refresh();
          });
        }}
      ></DeleteRow>
      <YesOrNoDialoge
        checkState={checkState}
        setCheckState={setCheckState}
        callback={() => {
          setProgress(true);
          UpdateUserPoll(checkState.sendModel, () => {
            setProgress(false);
            GetUserPoll(
              myPc,
              search,
              (polls) => {
                setPollRes(polls);
              },
              false
            );
          });
        }}
      />
    </Detail>
  );
}
